module.exports = __webpack_public_path__ + "img/product_17.7963a9a.svg";